import React from 'react';
import { Hero } from '../components/Hero';
import { FeatureHighlights } from '../components/FeatureHighlights';
import { SpecialitiesSection } from '../components/SpecialitiesSection';
import { DoctorSection } from '../components/DoctorSection';
import { ClinicGallery } from '../components/ClinicGallery';
import { LocationMap } from '../components/ui/expand-map';
import { TestimonialsColumn } from '../components/ui/testimonials-columns-1';
import { useDentoData } from '../context/DentoContext';
import { motion } from 'motion/react';

export const HomePage = ({ onAppointmentClick }) => {
  const { hospitalData } = useDentoData();
  const testimonials = hospitalData.testimonials || [];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <Hero onAppointmentClick={onAppointmentClick} />

      {/* Feature Highlights */}
      <FeatureHighlights />

      {/* Services Grid */}
      <SpecialitiesSection />

      {/* Meet Our Doctor Section */}
      <DoctorSection />

      {/* Clinic Gallery Section */}
      <section id="gallery">
        <ClinicGallery />
      </section>

      {/* Patient Testimonials */}
      <section id="testimonials" className="py-24 bg-white overflow-hidden relative">
        <div className="container z-10 mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            viewport={{ once: true }}
            className="flex flex-col items-center justify-center max-w-[540px] mx-auto text-center mb-10 md:mb-16"
          >
            <h2 className="text-3xl md:text-5xl font-extrabold text-black mb-4 font-heading tracking-tight">
              Testimonials
            </h2>
            <div className="w-16 h-1.5 bg-black mx-auto mb-6 rounded-full"></div>
            <p className="text-center text-black/50 text-base md:text-lg font-body leading-relaxed">
              See what our customers have to say about their dental care experience.
            </p>
          </motion.div>

          <div className="flex justify-center gap-6 mt-6 md:mt-10 [mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)] max-h-[600px] md:max-h-[740px] overflow-hidden">
            <TestimonialsColumn testimonials={testimonials.filter((_, i) => i % 3 === 0)} duration={15} />
            <TestimonialsColumn className="hidden md:block" testimonials={testimonials.filter((_, i) => i % 3 === 1)} duration={19} />
            <TestimonialsColumn className="hidden lg:block" testimonials={testimonials.filter((_, i) => i % 3 === 2)} duration={17} />
          </div>
        </div>
      </section>

      {/* Centered Location Map */}
      <section className="pb-24 bg-white flex flex-col items-center">
        <h2 className="text-3xl md:text-5xl font-extrabold text-black mb-4 font-heading tracking-tight">
          Visit Us
        </h2>
        <div className="w-16 h-1.5 bg-black mx-auto mb-10 rounded-full"></div>
        <div className="relative">
          <div className="absolute -inset-4 bg-black/5 blur-3xl rounded-full scale-150" />
          <LocationMap
            location="Jaysingpur, Maharashtra"
            coordinates="16.7775° N, 74.5523° E"
          />
        </div>
      </section>

    </div>
  );
};